export const PreviewBreakPluginID = 'preview-break';
